/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type BypassDspDeviceFragment = {
	id: string;
	virtual: boolean;
	hardwareId: string;
	description: {
		model: string;
		features: {
			allEqualizersBypass: { supported: boolean };
			allIntellimixBypass: { supported: boolean };
			conferencingOperationMode: { supported: boolean };
			analogAudioOutputMode: { supported: boolean };
			authentication: { supported: boolean };
		};
	};
	features: {
		audioChannels: { audioChannels: Array<BypassChannelFragment> } | null;
		allIntellimixBypass: { bypassed: boolean } | null;
		allEqualizersBypass: { bypassed: boolean } | null;
		firmware: { version: string } | null;
		ethernetPowerSource: { type: Types.EthernetPowerSourceType } | null;
		conferencingOperationMode: { mode: Types.ConferencingOperationMode } | null;
		analogAudioOutputMode: { mode: Types.AnalogAudioOutputMode } | null;
		authentication: {
			credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
		} | null;
	};
};

export type BypassChannelFragment = {
	id: string;
	isAudioChannelNode: 'AudioChannel';
	description: { groupName: string };
	features: { name: { name: string } | null };
};

export type BypassDspDeviceUpdateFragment = {
	id: string;
	features:
		| { allEqualizersBypass: { bypassed: boolean } | null }
		| { allIntellimixBypass: { bypassed: boolean } | null }
		| { analogAudioOutputMode: { mode: Types.AnalogAudioOutputMode } | null }
		| {
				authentication: {
					credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
				} | null;
		  }
		| { conferencingOperationMode: { mode: Types.ConferencingOperationMode } | null }
		| {};
};

export type BypassDspDeviceQueryVariables = Types.Exact<{
	deviceId: Types.Scalars['ID']['input'];
}>;

export type BypassDspDeviceQueryOpResult = { node: BypassDspDeviceFragment | {} };

export type BypassDspDeviceSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type BypassDspDeviceSubscriptionOpResult = {
	nodeChanges: BypassDspDeviceFragment | BypassDspDeviceUpdateFragment | {};
};

export type BypassIntellimixMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type BypassIntellimixMutationOpResult = {
	updateNodes: Array<
		| {
				device: { features: { allIntellimixBypass: { bypassed: boolean } | null } } | null;
				error: { code: Types.ErrorCode; message: string } | null;
		  }
		| {}
	>;
};

export type BypassAllEqMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type BypassAllEqMutationOpResult = {
	updateNodes: Array<
		| {
				device: { features: { allEqualizersBypass: { bypassed: boolean } | null } } | null;
				error: { code: Types.ErrorCode; message: string } | null;
		  }
		| {}
	>;
};

export const BypassChannelFragment = gql`
	fragment BypassChannelFragment on AudioChannel {
		isAudioChannelNode: __typename
		id
		description {
			groupName
		}
		features {
			name {
				name
			}
		}
	}
`;
export const BypassDspDeviceFragment = gql`
	fragment BypassDspDeviceFragment on Device {
		id
		virtual
		description {
			model
			features {
				allEqualizersBypass {
					supported
				}
				allIntellimixBypass {
					supported
				}
				conferencingOperationMode {
					supported
				}
				analogAudioOutputMode {
					supported
				}
				authentication {
					supported
				}
			}
		}
		features {
			audioChannels {
				audioChannels {
					... on AudioChannel {
						...BypassChannelFragment
					}
				}
			}
			allIntellimixBypass {
				bypassed
			}
			allEqualizersBypass {
				bypassed
			}
			firmware {
				version
			}
			ethernetPowerSource {
				type
			}
			conferencingOperationMode {
				mode
			}
			analogAudioOutputMode {
				mode
			}
			authentication {
				credentials {
					accessLevel
					credentialsState
				}
			}
		}
		hardwareId
	}
	${BypassChannelFragment}
`;
export const BypassDspDeviceUpdateFragment = gql`
	fragment BypassDspDeviceUpdateFragment on DeviceChange {
		id
		features {
			... on DeviceAllIntellimixBypassChange {
				allIntellimixBypass {
					bypassed
				}
			}
			... on DeviceAllEqualizersBypassChange {
				allEqualizersBypass {
					bypassed
				}
			}
			... on DeviceConferencingOperationModeChange {
				conferencingOperationMode {
					mode
				}
			}
			... on DeviceAnalogAudioOutputModeChange {
				analogAudioOutputMode {
					mode
				}
			}
			... on DeviceAuthenticationChange {
				authentication {
					credentials {
						accessLevel
						credentialsState
					}
				}
			}
		}
	}
`;
export const BypassDspDeviceQueryDocument = gql`
	query BypassDspDeviceQuery($deviceId: ID!) {
		node(id: $deviceId) {
			...BypassDspDeviceFragment
		}
	}
	${BypassDspDeviceFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class BypassDspDeviceQueryGQL extends Apollo.Query<BypassDspDeviceQueryOpResult, BypassDspDeviceQueryVariables> {
	override document = BypassDspDeviceQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const BypassDspDeviceSubscriptionDocument = gql`
	subscription BypassDspDeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on Device {
				...BypassDspDeviceFragment
			}
			... on DeviceChange {
				...BypassDspDeviceUpdateFragment
			}
		}
	}
	${BypassDspDeviceFragment}
	${BypassDspDeviceUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class BypassDspDeviceSubscriptionGQL extends Apollo.Subscription<
	BypassDspDeviceSubscriptionOpResult,
	BypassDspDeviceSubscriptionVariables
> {
	override document = BypassDspDeviceSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const BypassIntellimixMutationDocument = gql`
	mutation BypassIntellimixMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on DeviceOperationResult {
				device {
					features {
						allIntellimixBypass {
							bypassed
						}
					}
				}
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class BypassIntellimixMutationGQL extends Apollo.Mutation<
	BypassIntellimixMutationOpResult,
	BypassIntellimixMutationVariables
> {
	override document = BypassIntellimixMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const BypassAllEqMutationDocument = gql`
	mutation BypassAllEqMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on DeviceOperationResult {
				device {
					features {
						allEqualizersBypass {
							bypassed
						}
					}
				}
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class BypassAllEqMutationGQL extends Apollo.Mutation<BypassAllEqMutationOpResult, BypassAllEqMutationVariables> {
	override document = BypassAllEqMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
